export const GET_POST_DATA = "GET_POST_DATA" 